import { Component, OnInit, Input } from '@angular/core';
import { HttpModule } from '@angular/http';
import { Validators, FormGroup, FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';

import 'moment/locale/pt-br';

// Service
import { CockpitService } from '../../../service/cockpit/cockpit.service';

@Component({
	selector: 'app-commercial-competence-proposal',
	templateUrl: './commercial-competence.component.html',
	providers: [
		CockpitService,
		HttpModule
	]
})
export class CockpitCommercialCompetenceComponent implements OnInit {

	@Input('follow') follow: boolean;

	public alcadasComerciais: any[] = [];
	public orderby: string = "NumeroProposta";
	public sort: string = "asc";

	constructor(private CockpitService: CockpitService, private router: Router, private route: ActivatedRoute, private flashMessagesService: FlashMessagesService) {
	}

	ngOnInit() {
		this.getAlcadasComerciais();
	}

	setOrder(orderby) {
		if (this.orderby != orderby) {
			this.sort = "asc";
		} else {
			this.sort = this.sort == "asc" ? "desc" : "asc"; 
		}
		this.orderby = this.orderby != orderby ? orderby : this.orderby;
		this.getAlcadasComerciais();
	}

	getAlcadasComerciais() {
		this.CockpitService.getAlcadasComerciais(this.follow, this.orderby, this.sort).subscribe(result => {
			if (result.Success) {
				this.alcadasComerciais = result.Result;
				console.log("alcadas",this.alcadasComerciais)
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/cockpit/component/cockpit/commercial-competence-proposal/commercial-competence.component.ts